import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {take} from 'rxjs/operators';
import {DemonstrativosFaturasService} from 'src/app/services/demonstrativos-faturas.service';
import { AlertDetalheFaturaComponent } from './alert-detalhe-fatura/alert-detalhe-fatura.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { NgxMaskDirective } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { NgClass, AsyncPipe } from '@angular/common';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { SelectComponent } from '../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-demonstrativos-faturas',
    templateUrl: './demonstrativos-faturas.component.html',
    styleUrls: ['./demonstrativos-faturas.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertDetalheFaturaComponent, HeaderComponent, BotaoChatComponent, NgxMaskDirective, FormsModule, NgClass, BreadcrumbComponent, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, PopoverDirective, SelectComponent, NgxPaginationModule, FooterComponent, AsyncPipe, CnpjPipe, UsuarioPermissaoPipe, AppDatePipe]
})
export class DemonstrativosFaturasComponent implements OnInit {

  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public cnpjInput: string;
  public faturas: any = [];
  public showAlertFatura = false;
  public dadosDetalheFatura: any = null;
  public faturasPorPagina = '6';
  public paginaFatura = 1;
  public totalFaturas: number;

  // FILTROS
  public tipoBusca = '';

  public filtrarData = false;
  public dataFiltrada = false;
  public dataInicial: any = '';
  public dataFinal: any = '';
  public cnpjFiltrado = false;
  dataFinalFormatada: any;
  dataInicialFormatada: any;

  constructor(private readonly service: DemonstrativosFaturasService) {
  }

  ngOnInit(): void {
    this.filtrarData = false;
    this.dataFinalFormatada = '';
    this.dataInicialFormatada = '';

    this.getAllFaturas();
  }

  getAllFaturas() {
    this.faturas = null;

    this.service.getAllFaturas(this.idEmpresaLogada, this.cnpjInput, this.tipoBusca, this.dataInicialFormatada, this.dataFinalFormatada)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'OK' && response.response?.data?.length) {
            this.faturas = response.response.data;
            this.totalFaturas = response.response.pageRequest.total;
          } else {
            this.faturas = undefined;
          }
        },
        error: (erro: any) => {
          if (erro.error.status === 'NOK') {
            this.faturas = undefined;
          } else {
            this.faturas = false;
          }
        }
      });
  }

  detalharFatura(codigoNf: string, idNotaFiscal: number) {

    this.showAlertFatura = true;

    this.service.getRpsEspecifico(idNotaFiscal, codigoNf).pipe(take(1))
    .subscribe({
      next: (response: any) => {
        const html = response.response;
        this.dadosDetalheFatura = html;
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  fecharAlertFatura(evento: any) {
    this.showAlertFatura = false;
    this.dadosDetalheFatura = null;
  }

  // FUNÇÕES DE FILTROS DOS BOTÕES DE CIMA
  filtrarBotao(parametroFiltro: string) {
    this.filtrarData = false;
    this.dataFinalFormatada = '';
    this.dataInicialFormatada = '';
    this.tipoBusca = parametroFiltro;
    this.getAllFaturas();

  }

  filtrarBotaoData() {
    if (this.dataInicial && this.dataFinal) {
      this.dataFinalFormatada = this.dataFinal.toLocaleDateString('pt-BR');
      this.dataInicialFormatada = this.dataInicial.toLocaleDateString('pt-BR');

      this.dataFiltrada = true;
      this.tipoBusca = 'UP';
      this.getAllFaturas();
    }
  }

  limparFiltro() {
    this.filtrarData = false;
    this.dataFiltrada = false;
    this.dataInicial = '';
    this.dataFinal = '';
    this.dataFinalFormatada = '';
    this.dataInicialFormatada = '';
    this.cnpjInput = '';
    this.cnpjFiltrado = false;

    this.tipoBusca = '';
    this.getAllFaturas();
  }

  buscarPorCNPJ() {
    this.cnpjFiltrado = true;
    this.paginaFatura = 0;
    this.getAllFaturas();
  }

  marcarLeitura(indexEmpresa, indexFatura: number) {
    this.faturas[indexEmpresa].detalhes[indexFatura].flagImpressaoNF = 'S';
    this.getNF(indexEmpresa);
  }

  getNF(index) {
    this.service.getFaturaEspecifica(this.faturas[0].detalhes[index].idNotaFiscal, this.faturas[0].detalhes[index].numeroSerieNF)
    .pipe(take(1)).subscribe({
      next: (response: any) => {
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  onFaturasPorPaginaChange(itemsPerPage: string) {
    this.faturasPorPagina = itemsPerPage;
    this.paginaFatura = 1;
  }
}
